/**
 * Club Welkit — ajout/retrait de l'adhesion depuis la fiche produit.
 *
 * Deux responsabilites :
 *   1. Basculer l'adhesion dans le panier quand on actionne l'interrupteur.
 *   2. Resynchroniser l'interrupteur avec l'etat REEL du panier — car le
 *      client peut retirer l'adhesion depuis le drawer ou la page panier,
 *      sans repasser par la fiche. L'interrupteur restait alors coche a tort.
 *
 * API evenementielle du theme Enterprise :
 *   dispatch:cart-drawer:refresh  (le drawer se re-rend lui-meme)
 *   dispatch:cart-drawer:open
 *
 * Ecouteurs delegues au document : ils survivent aux re-rendus dynamiques de
 * variante (Section Rendering API).
 */
(() => {
  if (window.__clubWelkitInit) return;
  window.__clubWelkitInit = true;

  const ADHESION_HANDLE = 'adhesion-club-welkit';

  async function setAdhesion(variantId, ajouter) {
    const url = ajouter ? '/cart/add.js' : '/cart/change.js';
    const body = ajouter
      ? { items: [{ id: Number(variantId), quantity: 1 }] }
      : { id: String(variantId), quantity: 0 };

    const res = await fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body),
    });
    if (!res.ok) throw new Error(`Club Welkit: ${url} -> ${res.status}`);
    return res.json();
  }

  /* ------------------------------------------------ Resynchronisation ---- */

  let syncEnCours = false;

  /** Aligne les interrupteurs de la page sur le contenu reel du panier. */
  async function resync() {
    const boxes = document.querySelectorAll('[data-club-adhesion]');
    if (!boxes.length || syncEnCours) return;

    syncEnCours = true;
    try {
      const res = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
      if (!res.ok) return;
      const cart = await res.json();
      const present = (cart.items || []).some((i) => i.handle === ADHESION_HANDLE);

      boxes.forEach((box) => {
        // On ne touche pas a un interrupteur en cours de bascule : sa valeur
        // fait foi jusqu'a la fin de la requete.
        if (box.disabled) return;
        if (box.checked !== present) box.checked = present;
      });
    } catch (err) {
      console.error(err);
    } finally {
      syncEnCours = false;
    }
  }

  let resyncTimer = null;
  function resyncBientot() {
    clearTimeout(resyncTimer);
    // Laisse le theme terminer son appel panier avant de relire /cart.js.
    resyncTimer = setTimeout(resync, 350);
  }

  /* ---------------------------------------------------------- Bascule ---- */

  // Ecoute en phase de CAPTURE, pas de bulle. Raison : le bloc club du panier
  // vit a l'interieur de <cart-items>, qui ecoute lui aussi 'change' et traite
  // tout evenement recu comme un changement de quantite de ligne
  // (handleChange -> updateQuantity). En bulle, le theme recevait donc notre
  // case a cocher avant nous, lancait un /cart/change.js incoherent et
  // re-rendait le panier — l'adhesion n'etait jamais ajoutee. En capture, on
  // passe avant lui et on coupe la propagation.
  document.addEventListener(
    'change',
    async (evt) => {
      const box = evt.target.closest?.('[data-club-adhesion]');
      if (!box) return;

      evt.stopPropagation();

      const variantId = box.dataset.variantId;
      if (!variantId) return;

      const voulu = box.checked;
      box.disabled = true;
      try {
        await setAdhesion(variantId, voulu);

        // Page panier : le recapitulatif, les totaux et les prix de ligne sont
        // rendus par le serveur hors de la zone que nous controlons — on
        // recharge pour que tout soit coherent d'un coup.
        if (document.querySelector('.cc-main-cart')) {
          window.location.reload();
          return;
        }

        document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh'));
        if (voulu) document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:open'));
      } catch (err) {
        box.checked = !voulu;
        console.error(err);
      } finally {
        box.disabled = false;
      }
    },
    true,
  );

  /* --------------------------------------------------- Declencheurs ------ */

  // Le theme n'emet aucun evenement « panier modifie » exploitable : le drawer
  // se re-rend par remplacement de son contenu. On surveille donc le compteur
  // d'articles de l'en-tete, qui change a chaque mutation du panier, quelle
  // qu'en soit l'origine (drawer, page panier, autre onglet du meme parcours).
  function observerCompteur() {
    const cible = document.getElementById('cart-icon');
    if (!cible) return;
    new MutationObserver(resyncBientot).observe(cible, {
      childList: true,
      subtree: true,
      characterData: true,
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observerCompteur, { once: true });
  } else {
    observerCompteur();
  }

  // Filets complementaires : retour sur l'onglet, retour arriere navigateur,
  // et rafraichissement du drawer declenche par un autre composant.
  document.addEventListener('visibilitychange', () => {
    if (!document.hidden) resyncBientot();
  });
  window.addEventListener('pageshow', resyncBientot);
  document.addEventListener('dispatch:cart-drawer:refresh', resyncBientot);
})();
